export default (someValue, otherValue) =>
  String(someValue) !== String(otherValue)
